import Navabrr from '../Navbar/Navbarr';
// import StickyMenu from '../stickyMenu/StickyMenu';
import './header.css';

function Header() {
  return (
    <section className="header">
      <Navabrr />
      {/* <StickyMenu /> */}
    </section>
  );
}

export default Header;
